import React, { useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from "@material-ui/core/FormLabel";
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import MessageBox from "../../components/MessageBox/MessageBox";
import Preloader from "../../components/Preloader/Preloader";
import LoadingOverlay from "react-loading-overlay";
import ReactPDF from "@react-pdf/renderer";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { PdfDocument } from "../../components/PDF/WholesaleSetPdf";
import { PdfDocumentFS } from "../../components/PDF/PackageSalesSummaryPdfFS";
import ReactToPrint from "react-to-print";
import { get_cookies, isLoggedIn } from "../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
  cardStyleHeight: {
    height: "100%",
  },
  floatright: {
    float: "right",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    maxWidth: "600px",
    margin: "0 auto",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "800px",
  },
  paddingmarginzero: {
    padding: "0 !important",
    margin: "0 !important",
    fontWeight: "bold",
  },
  margintop: {
    marginTop: "10px",
  },
}));

const WholesaleTransactionDetails = (props) => {
  const classes = useStyles();
  const idnoselected = props.location.idno ? props.location.idno : "";
  const eligibleforrelease = props.location.eligibleforrelease
    ? props.location.eligibleforrelease
    : "";
  //ApiData Component useState SOF
  const [nextPagePath, setnextPagePath] = useState("");
  const [branchIdNo, setBranchIdNo] = useState(get_cookies("branchidno"));
  const [branchCurcode, setBranchCurcode] = useState(get_cookies("curcode"));
  const [isLoaded, setisLoaded] = useState(false);
  const [headerDetailsP, setHeaderDetailsP] = useState([]);
  const [itemDetailsP, setItemDetailsP] = useState([]);
  const [computationDetailsP, setComputationDetailsP] = useState([]);
  const [showPrint, setHidePrint] = useState(false);
  //Core datas
  const [memberpaymentsDetails, setmemberpaymentsDetails] = useState({});
  const [paymentDetails, setpaymentDetails] = useState({});
  const [itemDetails, setitemDetails] = useState({});
  const [computationDetails, setcomputationDetails] = useState({});
  const [transactionDetails, setTransactionDetails] = useState({});
  const toprint = useRef(null);
  const headers = {
    "Content-Type": "multipart/form-data",
    "Access-Control-Allow-Origin": process.env.REACT_APP_API_URL,
  };
  const get_packagesales_details = () => {
    setisLoaded(false);
    //get data for warehouse/location dropdown
    const form_data = {
      hqidno: branchIdNo,
      idno: idnoselected,
      jc_curcode: branchCurcode,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "wholesalessummarydetails";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      setmemberpaymentsDetails(res.data.memberpaymentsDetails);
      setpaymentDetails(res.data.paymentDetails);
      setitemDetails(res.data.itemDetails);
      setcomputationDetails(res.data.computations);
      setisLoaded(true);
    });
  };

  const get_wholesale_details = () => {

    //get data for warehouse/location dropdown
    const form_data = {
      hqidno: branchIdNo,
      idno: idnoselected,
      jc_curcode: branchCurcode,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "getwholesadetails";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      setmemberpaymentsDetails(res.data.memberpaymentsDetails);
      setpaymentDetails(res.data.paymentDetails);
      setisLoaded(true);
    });
  };

  //   const get_packagesales_details_fs = () => {
  //     //get data for warehouse/location dropdown
  //     const form_data = {
  //       idno: idnoselected,
  //     };
  //     const formData = new FormData();
  //     formData.append("form_data", JSON.stringify(form_data));
  //     const apiUrl =
  //       process.env.REACT_APP_API_URL + "packagesalessummarydetailsfs";
  //     axios.post(apiUrl, formData, { headers: headers }).then((res) => {
  //       setTransactionDetails(res.data.transactioninfo);
  //       setHidePrint(true);
  //       setisLoaded(true);
  //     });
  //   };

  const get_packagedetailspdf = () => {
    setisLoaded(false);
    //get data for warehouse/location dropdown
    const form_data = {
      hqidno: branchIdNo,
      idno: idnoselected,
      curcode: branchCurcode,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "getpackagedetailspdf";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      setHeaderDetailsP(res.data.header_details);
      setItemDetailsP(res.data.item_details);
      setComputationDetailsP(res.data.computations_details);
      setShowOverlay(false);
      setHidePrint(true);
 
    });
  };
  const getWholesalePdf = () => {
    setShowOverlay(true);
    //get data for warehouse/location dropdown
    const form_data = {
      hqidno: branchIdNo,
      idno: idnoselected,
      curcode: branchCurcode,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "getwholesalepdf";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      setHeaderDetailsP(res.data.header_details);
      setItemDetailsP(res.data.item_details);
      setComputationDetailsP(res.data.computations_details);
      setShowOverlay(false);
      setHidePrint(true);
      
    });
  
  };
  const getitrdetails = () => {
    //get data for warehouse/location dropdown
    const form_data = {
      hqidno: branchIdNo,
      idno: idnoselected,
      curcode: branchCurcode,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "getitrdetails";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      // setHeaderDetailsP(res.data.header_details);
      setitemDetails(res.data.itemDetails);
      setcomputationDetails(res.data.computations);

    });
  };

  const releasepackage = (idno) => {
    setShowOverlay(true);
    setOverlayMsg("Processing Release...");
    //get data for warehouse/location dropdown
    const form_data = {
      hqidno: branchIdNo,
      idno: idno,
      username:get_cookies('username'),
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "releasewholesale";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      if (res.data.data.successful == 1) {
        setShowMsgBox(true);
        setMsg('Successfully Released Wholesale Set');
        setMsgType("success");
        setTimeout(() => {
          setShowOverlay(false);
          setOverlayMsg("");
          setShowMsgBox(false);
          window.location.reload(false);
        }, 3000);
      } else {
        setShowMsgBox(true);
        setMsg(res.data.data.message);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setShowOverlay(false);
          window.location.reload(false);
        }, 3000);
      }
    });
  };
  //ApiData Component useState EOF

  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  //Message Box EOF

  //Loading overlay
  const [showOverlay, setShowOverlay] = useState(true);
  const [overLayMsg, setOverlayMsg] = useState("Loading...");
  //Loading overlay EOF

  //Table Settings
  const [TABLE_DATA_PAYMENT, loadPaymentTable] = useState([]);
  const [TABLE_DATA_ITEMS, loadItemTable] = useState([]);

  const prep_table_payment = () => {
    const newData = [...TABLE_DATA_PAYMENT];
    for (let i = 0; i < paymentDetails.length; i++) {
      const tempObj = {
        paymenttype: paymentDetails[i].paymentid,
        refno: paymentDetails[i].refno,
        amount: paymentDetails[i].amount,
      };
      newData.push(tempObj);
    }
    loadPaymentTable([...newData]);
  };

  const prep_table_item = () => {
    const newData = [...TABLE_DATA_ITEMS];
      for (let i = 0; i < itemDetails.length; i++) {
        const tempObj = {
          itemname: itemDetails[i].itemname,
          itemqty: Math.abs(itemDetails[i].qty),
          unit: itemDetails[i].unit,
          itemprice: itemDetails[i].itemprice,
          totalamt: itemDetails[i].totalamount,
        };
        newData.push(tempObj);
      }
    loadItemTable([...newData]);
  };

  const refreshTables = (params) => {
    if (params == "payment") {
      TABLE_DATA_PAYMENT.length = 0;
      const newData = [...TABLE_DATA_PAYMENT];
      loadPaymentTable([...newData]);
    } else {
      TABLE_DATA_ITEMS.length = 0;
      const newData = [...TABLE_DATA_ITEMS];
      loadItemTable([...newData]);
    }
  };

  const TABLE_COLUMNS_PAYMENT = [
    {
      name: "paymenttype",
      label: "Type",
    },
    {
      name: "refno",
      label: "Reference",
    },
    {
      name: "amount",
      label: "Amount",
    },
  ];

  const TABLE_COLUMNS_ITEMS = [
    {
      name: "itemname",
      label: "Item Name",
    },
    {
      name: "itemqty",
      label: "Qty",
    },
    {
      name: "unit",
      label: "Unit",
    },
    {
      name: "itemprice",
      label: "Price",
    },
    {
      name: "totalamt",
      label: "Total",
    },
  ];

  const TABLE_OPTION_PAYMENT = {
    selectableRows: false,
		toolbar:false,
		filter: false,
		viewColumns: false,
		search: false,
		download: false,
		print: false,
		csv: false,
    pagination: false,
  };

  const TABLE_OPTION_ITEMS = {
    selectableRows: false,
		toolbar:false,
		filter: false,
		viewColumns: false,
		search: false,
		download: false,
		print: false,
		csv: false,
  };
  //Table Settings EOF

  //Modal Settings
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  //Modal Settings EOF

  //OnLoad Event/Data Fetching SOF
  useEffect(() => {
    isLoggedIn();
    
    if(eligibleforrelease == "yes"){
      getWholesalePdf();
      get_wholesale_details();
      getitrdetails();
    }else{
      get_packagesales_details();
      get_packagedetailspdf();
    }


  }, []);
  useEffect(() => {
    refreshTables("payment");
    prep_table_payment();
  }, [paymentDetails]);
  useEffect(() => {
    refreshTables("items");
    prep_table_item();
  }, [itemDetails]);
  //OnLoad Event/Data Fetching SOF

  //Api Functions SOF
  // Code blocks here
  //Api Request Functions EOF

  //FormData
  const [prep_data, setData] = useState({});
  //FormData EOF
  // const nextpage =  {
  // 	// pathname: "/package-sales-payment",
  // 	pathname: nextPagePath,
  // 	transactionInfo: TransactionInformation, // your data array of objects
  // 	selectedpackagesInfo:TABLE_DATA,
  // 	pageInfo: {
  // 		navid: navid,
  // 		navname: CurrentPage
  // 	}
  // }
  const confirmrelease = () => {
    handleOpen();
  };
  return !idnoselected ? (
    <Redirect to="/wholesale-transaction-history/" />
  ) : (
    <div className="page">
      <LoadingOverlay active={showOverlay} spinner text={overLayMsg}>
        <div className="page-header noprint">
          <div className="page-icon">
            <LoyaltyTwoTone />
          </div>
          <Breadcrumbs aria-label="breadcrumb">
            <NavLink to="/Wholesale">
              <h4 className="header-title">Wholesale Set</h4>
            </NavLink>
            <NavLink to="/wholesale-transaction-history">
              <h4 className="header-title">
                Wholesale Set Transaction History
              </h4>
            </NavLink>
            <Typography color="textPrimary">
              Wholesale Set Transaction Details
            </Typography>
          </Breadcrumbs>
        </div>

        {!isLoaded ? (
          <Preloader />
        ) : (
          <div className="page-container">
            <form noValidate autoComplete="off">
              <MessageBox
                in={showMsgBox}
                content={msgBoxContent}
                type={msgType}
              />
              <Grid
                container
                spacing={2}
                alignItems="stretch"
                justify="center"
                className={classes.root}
              >
                {props.location.isfs == "" ? (
                  <Grid item xs={6}>
                    <Card>
                      <CardContent>
                        <div className={classes.cardStyleHeight}>
                        <div>
                              <div className="table-title">Transaction Information</div>
                            </div>
                          {/* <Grid container spacing={1}>
                            <Grid xs={12} sm={6}>
                              <h4 className={classes.title}>
                                Transaction Information
                              </h4>
                            </Grid>
                            <Grid xs={12} sm={6}>
                              <div className={[classes.floatright]}>
                                <Grid
                                  xs={12}
                                  className={classes.paddingmarginzerostyle}
                                >
                                  <FormLabel
                                    className={classes.paddingmarginzerostyle}
                                  >
                                    {memberpaymentsDetails.refno}
                                  </FormLabel>
                                </Grid>
                                <Grid
                                  xs={12}
                                  className={classes.paddingmarginzerostyle}
                                >
                                  <FormLabel
                                    className={classes.paddingmarginzerostyle}
                                  >
                                    {memberpaymentsDetails.date}
                                  </FormLabel>
                                </Grid>
                              </div>
                            </Grid>
                          </Grid> */}
                          <Grid container>
                            <Grid item xs={12}>
                              <Grid container>
                                <Grid xs={12} sm={12}>
                                  <h4 className={classes.title}>
                                    {memberpaymentsDetails.soldto}
                                  </h4>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid xs={12} sm={3}>
                                  <FormLabel>Transaction Date:</FormLabel>
                                </Grid>
                                <Grid xs={12} sm={9}>
                                  <FormLabel>
                                    {memberpaymentsDetails.date}
                                  </FormLabel>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid xs={12} sm={3}>
                                  <FormLabel>ID No.:</FormLabel>
                                </Grid>
                                <Grid xs={12} sm={9}>
                                  <FormLabel>
                                    {memberpaymentsDetails.idno}
                                  </FormLabel>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid xs={12} sm={3}>
                                  <FormLabel>Reference No:</FormLabel>
                                </Grid>
                                <Grid xs={12} sm={9}>
                                  <FormLabel>
                                    {memberpaymentsDetails.refno}
                                  </FormLabel>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid xs={12} sm={3}>
                                  <FormLabel>Account Type:</FormLabel>
                                </Grid>
                                <Grid xs={12} sm={9}>
                                  <FormLabel>
                                    {memberpaymentsDetails.accounttype}
                                  </FormLabel>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid xs={12} sm={3}>
                                  <FormLabel>Account Type Name:</FormLabel>
                                </Grid>
                                <Grid xs={12} sm={9}>
                                  <FormLabel>
                                    {memberpaymentsDetails.accounttypename}
                                  </FormLabel>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid xs={12} sm={3}>
                                  <FormLabel>Location:</FormLabel>
                                </Grid>
                                <Grid xs={12} sm={9}>
                                  <FormLabel>
                                    {memberpaymentsDetails.location}
                                  </FormLabel>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid xs={12} sm={3}>
                                  <FormLabel>Wholesale Set Price:</FormLabel>
                                </Grid>
                                <Grid xs={12} sm={9}>
                                  <FormLabel>
                                    {memberpaymentsDetails.amount}
                                  </FormLabel>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid xs={12} sm={3}>
                                  <FormLabel>Set:</FormLabel>
                                </Grid>
                                <Grid xs={12} sm={9}>
                                  <FormLabel>
                                    {memberpaymentsDetails.package}
                                  </FormLabel>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                ) : null}
                {!props.location.isfs == "" ? (
                  <Grid item xs={12}>
                    <Card>
                      <CardContent>
                        <div className={classes.cardStyleHeight}>
                          <Grid container spacing={1}>
                            <Grid xs={12} sm={6}>
                              <h4 className={classes.title}>
                                Transaction Information
                              </h4>
                            </Grid>
                            <Grid xs={12} sm={6}>
                              <div className={[classes.floatright]}>
                                <Grid
                                  xs={12}
                                  className={classes.paddingmarginzerostyle}
                                >
                                  <FormLabel
                                    className={classes.paddingmarginzerostyle}
                                  >
                                    {transactionDetails.refno}
                                  </FormLabel>
                                </Grid>
                                <Grid
                                  xs={12}
                                  className={classes.paddingmarginzerostyle}
                                >
                                  <FormLabel
                                    className={classes.paddingmarginzerostyle}
                                  >
                                    {transactionDetails.date}
                                  </FormLabel>
                                </Grid>
                              </div>
                            </Grid>
                          </Grid>
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <Grid container>
                                <Grid xs={12} sm={3}>
                                  <h4 className={classes.title}>
                                    {transactionDetails.soldto}
                                  </h4>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid xs={12} sm={3}>
                                  <FormLabel>
                                    ID No.: {transactionDetails.idno}
                                  </FormLabel>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid xs={12} sm={3}>
                                  <FormLabel>
                                    Pin No: {transactionDetails.pinno}
                                  </FormLabel>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid xs={12} sm={3}>
                                  <FormLabel>
                                    Activation No. {transactionDetails.actno}
                                  </FormLabel>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                ) : null}
                {props.location.isfs == "" ? (
                  <Grid item xs={6}>
                    <Grid container>
                      <Grid item xs={12}>
                        <MUIDataTable
                          title={
                            <div>
                              <div className="table-title">Payment Details</div>
                            </div>
                          }
                          id="table-grid-payment"
                          data={TABLE_DATA_PAYMENT}
                          columns={TABLE_COLUMNS_PAYMENT}
                          options={TABLE_OPTION_PAYMENT}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null}

                <Grid item xs={12} className="noprint">
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <MUIDataTable
                        title={
                          <div>
                            <div className="table-title">Item Details</div>
                          </div>
                        }
                        id="table-grid"
                        data={TABLE_DATA_ITEMS}
                        columns={TABLE_COLUMNS_ITEMS}
                        options={{
                          ...TABLE_OPTION_ITEMS,
                          pagination: false,
                          customFooter: (
                            count,
                            page,
                            rowsPerPage,
                            changeRowsPerPage,
                            changePage
                          ) =>
                            computationDetails.total_amount_display ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  padding: "20px",
                                }}
                              >
                                <span style={{ fontWeight: "bold" }}>
                                  Total Amount:{" "}
                                  {computationDetails.total_amount_display}
                                </span>
                              </div>
                            ) : null,
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {!props.location.isfs == "" ? (
                  <Grid item xs={12} className="yesprint">
                    <Card>
                      <CardContent>
                        <Grid container spacing={2}>
                          <Grid item xs={2}>
                            No.
                          </Grid>
                          <Grid item xs={2}>
                            Item Name
                          </Grid>
                          <Grid item xs={2}>
                            Qty
                          </Grid>
                          <Grid item xs={2}>
                            Unit
                          </Grid>
                          <Grid item xs={2}>
                            Price
                          </Grid>
                          <Grid item xs={2}>
                            Total
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                ) : null}
                {props.location.isfs == "" ? (
                  <Grid container xs={12}>
                    {!computationDetails.freightcharge == "" ? (
                      <Grid item xs={12}>
                        <h4 className={classes.floatright}>
                          Shipping/Freight: {computationDetails.freightcharge}
                        </h4>
                      </Grid>
                    ) : null}
                    {!computationDetails.discount == "" ? (
                      <Grid item xs={12}>
                        <h4 className={classes.floatright}>
                          Discount: {computationDetails.discount}
                        </h4>
                      </Grid>
                    ) : null}
                    {!computationDetails.netamountnovat == "" ? (
                      <Grid item xs={12}>
                        <h4 className={classes.floatright}>
                          Net Amount: {computationDetails.netamountnovat}
                        </h4>
                      </Grid>
                    ) : null}
                    {!computationDetails.vatamount == "" ? (
                      <Grid item xs={12}>
                        <h4 className={classes.floatright}>
                          VAT Amount: {computationDetails.vatamount}
                        </h4>
                      </Grid>
                    ) : null}
                    {!computationDetails.grandtotal == "" ? (
                      <Grid item xs={12}>
                        <h4 className={classes.floatright}>
                          Grand Total: {computationDetails.grandtotal}
                        </h4>
                      </Grid>
                    ) : null}
                  </Grid>
                ) : null}
              </Grid>
              <Grid container className={[classes.margintop, "noprint"]}>
                {eligibleforrelease == "yes" ? (
                  <div>
                    <Grid item xs="12" sm="3" style={{ paddingRight: "5px" }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={(e) => {
                          confirmrelease();
                        }}
                      >
                        Release
                      </Button>
                    </Grid>
                  </div>
                ) : null}

                <Grid item xs="12" sm="3">
                  {props.location.isfs == "" ? (
                    <div>
                      {showPrint && (
                        <Button
                          variant="contained"
                          color="success"
                          style={{
                            color: "white",
                            backgroundColor: "green",
                          }}
                        >
                          <PDFDownloadLink
                            document={
                              <PdfDocument
                                className="MuiButton-root"
                                headers={headerDetailsP}
                                setInfo={memberpaymentsDetails}
                                items={itemDetailsP}
                                computations={computationDetailsP}
                              />
                            }
                            fileName={"Wholesale" + idnoselected + ".pdf"}
                            style={{ color: "white" }}

                          >
                            {({ blob, url, loading, error }) =>
                              loading
                                ? "Loading document..."
                                : "Print Wholesale Set"
                            }
                          </PDFDownloadLink>
                        </Button>
                      )}
                    </div>
                  ) : null}
                </Grid>
              </Grid>
              <div>
                <Modal
                  aria-labelledby="transition-modal-title"
                  aria-describedby="transition-modal-description"
                  className={classes.modal}
                  open={open}
                  onClose={handleClose}
                  closeAfterTransition
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                    timeout: 500,
                  }}
                >
                  <Fade in={open}>
                    <div className={classes.paper}>
                      <h4 id="transition-modal-title">System Message</h4>
                      <form action="" className={classes.root}>
                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            Are you sure you want to release this set?
                          </Grid>
                        </Grid>
                        <div className={classes.button}>
                          <Grid container spacing={1}>
                            <Grid item xs={12} sm={2}>
                              <Button
                                variant="contained"
                                onClick={handleClose}
                                className={classes.buttonMarginRight}
                              >
                                No
                              </Button>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={(e) => {
                                  releasepackage(idnoselected);
                                  handleClose();
                                }}
                              >
                                Yes
                              </Button>
                            </Grid>
                          </Grid>
                        </div>
                      </form>
                    </div>
                  </Fade>
                </Modal>
              </div>
            </form>
          </div>
        )}
      </LoadingOverlay>
    </div>
  );
};

export default WholesaleTransactionDetails;
